import React, { useEffect } from 'react';
import styles from './RemainingTokens.module.scss';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';

const RemainingTokens = ({ botId, snapshotMode }) => {
  const { data: remainingTokens } = useFetch(
    ['remainingTokens', botId],
    dashboardEndpoints.getMessagesLeft(),
    { enabled: true },
    botId ? { botId: botId } : {}
  );

  const remaining = remainingTokens?.data?.total - remainingTokens?.data?.used;
  const total = remainingTokens?.data?.total;
  const remainingPercentage = (
    ((remainingTokens?.data?.total - remainingTokens?.data?.used) * 100) /
    remainingTokens?.data?.total
  ).toFixed(1);

  return (
    <div
      className={`${styles['remaining-tokens-container']} ${
        snapshotMode ? styles['snapshot-mode'] : ''
      }`}
    >
      <p className={styles['title']}>Remaining Tokens</p>
      <div className={styles['chart-container']}>
        <p className={styles['remaining']}>
          {remaining ? remaining?.toLocaleString() : ''}
        </p>
        <p className={styles['total']}>
          {total ? 'out of' : ''} {total ? total?.toLocaleString() : ''}
        </p>
        <div className={styles['tokens-bar']}>
          <div
            className={styles['used-bar']}
            style={{
              width: `${remainingPercentage}%`,
              backgroundColor:
                25 >= remainingPercentage ? '#C81111' : '#4c89ea',
            }}
          >
            <p className={styles['precentage']}>
              {Number(remainingPercentage) ? `${remainingPercentage}%` : ''}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemainingTokens;
